const StoreModules = {
  USER: 'user',
  PRODUCTS: 'products',
  PRODUCT_DETAIL: 'product_detail',
  PRODUCT_ATTRIBUTES: 'product_attributes',
  PRODUCT_GROUPS: 'product_groups',
  SYSTEMS: 'systems',
  SYSTEM_ATTRIBUTES: 'system_attributes',
  SYSTEM_GROUPS: 'system_groups',
  SYSTEM_DETAIL: 'system_detail',
  SYSTEM_APPLICATIONS: 'system_applications',
  NEWS: 'news',
  CART: 'cart',
  DELIVERY_ADDRESSES: 'delivery_addresses',
  CHECKOUT: 'checkout',
};

export default StoreModules;
